import { render, staticRenderFns } from "./split_flap.vue?vue&type=template&id=9482b92a&"
import script from "./split_flap.vue?vue&type=script&lang=js&"
export * from "./split_flap.vue?vue&type=script&lang=js&"
import style0 from "./split_flap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports